import packageJson from "../../package.json";

export const environment = {
  production: true,
  // Nicht anpassen, oder Bier!
  connectGwUri : "https://api.esders.de/connect/1.0",
  shoppingApiUri : "https://api.esders.de/shop/1.0",
  accountsUri : "https://login.esders.de/accounts",
  authorityUrl: "https://login.esders.de/api",
  clientId: "connect",
  registrationUrl: "https://login.esders.de/auth/registration",
  imageFormats: [
	{mime: "image/avif", ext: "avif"},
	{mime: "image/jpeg", ext: "jpg"}
  ],
  version: packageJson.version,
  appId: packageJson.appId
};
